import React from 'react';
import { Toaster } from 'sonner';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { MonthlyPopup } from './components/MonthlyPopup';
import { Workshops } from './components/Workshops';
import { About } from './components/About';
import { MissionStrip } from './components/MissionStrip';
import { VendorSection } from './components/VendorSection';
import { PartnerSection } from './components/PartnerSection';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-foodCream selection:bg-foodOrange selection:text-white" data-id="element-0" data-mp="31bibfrfi6shj">
      <Toaster position="bottom-right" toastOptions={{
      style: {
        background: '#F7F1E5',
        color: '#3D1610',
        border: '2px solid #3D1610',
        boxShadow: '4px 4px 0px 0px #3D1610',
        borderRadius: '0',
        fontWeight: 'bold',
        fontFamily: '"Inter", sans-serif'
      }
    }} data-id="element-1" data-mp="2wiyvintcfl9k" />

      <Nav data-id="element-2" data-mp="3mkrchhuehbbq" />

      <main data-id="element-3" data-mp="3mk8710lxsfel">
        <Hero data-id="element-4" data-mp="3mjztr7lwj82v" />
        <Marquee data-id="element-5" data-mp="3mjga9mglsbmq" />
        <MonthlyPopup data-id="element-6" data-mp="3rc9e8848zfxr" />
        <Workshops data-id="element-7" data-mp="3rbrcivytg9ig" />
        <About data-id="element-8" data-mp="3rdki07xp0nov" />
        <MissionStrip data-id="element-9" data-mp="3rcsulke91w9o" />
        <VendorSection data-id="element-10" data-mp="3relu8fqg3g86" />
        <PartnerSection data-id="element-11" data-mp="5opww5kum4f" />
        <Newsletter data-id="element-12" data-mp="4wwnrzgd0hb" />
      </main>

      <Footer data-id="element-13" data-mp="82kz509bybz" />
    </div>;
}